module.exports = __webpack_public_path__ + "static/media/OSTR08.995e96e7.jpg";